import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ScreenPickerProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { CodeActionType, ReadOnlyType } from 'app/area/codetable/item/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { configurationAlreadyExistsKey } from 'app/area/indicator-factors/constants';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const UomTypeFrom = (props: ScreenPickerProps) => {

  const { breadcrumbs, codeItem, updateByKey, resetValidation, codetableOptions, loadCodetableOptions,
    translation, validation, readOnlyConfig, actionType } = props;

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(ScreenPicker.uomTypeFrom);
    ((isDefinedIncludingZero(codeItem?.uomTypeTo?.value) && codeItem?.uomTypeFrom?.value !== value?.value &&
      codeItem?.uomTypeFrom?.value === codeItem?.uomTypeTo?.value) || validation[configurationAlreadyExistsKey])
      && resetValidation(ScreenPicker.uomTypeTo);
    updateByKey(ScreenPicker.uomTypeFrom, value);
  };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableOptionsIds.uomTypeFrom, loadOptionsParams);
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableOptionsIds.uomTypeFrom, breadcrumbs);

  const codeOptions = (codetableOptions?.[ScreenPicker.uomTypeFrom]?.codes || []) as CodeComplexValue<number>[];

  const uomTypeFromValidation = !!validation?.[ScreenPicker.uomTypeFrom] ? validation[ScreenPicker.uomTypeFrom] : undefined;

  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all] || actionType === CodeActionType.Edit;

  return <CodeSinglePicker
    id={ScreenPicker.uomTypeFrom}
    label={translation.uom_type_from}
    valueItem={codeItem && codeItem.uomTypeFrom}
    searchRequired={false}
    required={!readOnly}
    readOnly={readOnly}
    options={codeOptions}
    fetchingOptions={codetableOptions?.[ScreenPicker.uomTypeFrom]?.fetching}
    translation={translation}
    extraFooterButton={extraFooterButton}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    validation={uomTypeFromValidation}
  />;
};
